
import { Vue, Component, Prop, Emit } from "vue-property-decorator"

@Component
export default class TimePicker extends Vue {
  @Prop({ default: "" })
  private time!: string
  @Prop()
  private disabled!: boolean
  @Prop()
  private label!: string

  private modal = false

  @Emit("emitPublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitPublishTime(newTime: string, label: string) {
    /* */
  }
  @Emit("emitEndOfPublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitEndOfPublishTime(newTime: string, label: string) {
    /* */
  }
  @Emit("emitRssPublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitRssPublishTime(newTime: string, label: string) {
    /* */
  }

  @Emit("onlyChangePublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onlyChangePublishTime(newTime: string, label: string) {
    /* */
  }
  @Emit("onlyChangeEndOfPublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onlyChangeEndOfPublishTime(newTime: string, label: string) {
    /* */
  }
  @Emit("onlyChangeRssPublishTime")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onlyChangeRssPublishTime(newTime: string, label: string) {
    /* */
  }

  private emitTime(newTime: string) {
    if (this.label === "公開日") {
      this.emitPublishTime(newTime, this.label)
    } else if (this.label === "公開終了予定日") {
      this.emitEndOfPublishTime(newTime, this.label)
    } else if (this.label === "RSS公開日") {
      this.emitRssPublishTime(newTime, this.label)
    }
  }

  get innerTime(): string {
    const matched: RegExpMatchArray | null = this.time.match(/(\d{2}:\d{2})/)
    return matched ? matched[1] : "00:00"
  }

  set innerTime(newTime: string) {
    if (this.label === "公開日") {
      this.onlyChangePublishTime(newTime, this.label)
    } else if (this.label === "公開終了予定日") {
      this.onlyChangeEndOfPublishTime(newTime, this.label)
    } else if (this.label === "RSS公開日") {
      this.onlyChangeRssPublishTime(newTime, this.label)
    }
  }
}
